export default "__VITE_ASSET__C1UUR5gZ__"